import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-payment-management-company',
  templateUrl: './payment-management-company.component.html',
  styleUrls: ['./payment-management-company.component.scss']
})
export class PaymentManagementCompanyComponent implements OnInit {

  constructor( ) { }

  ngOnInit(): void {
  }

}
